import factory from './factory'

export default {
  all: factory.all,
  ordered: factory.ordered,
  filtered: factory.filtered,
  appliedFilters: factory.appliedFilters
}
